export default {
    setBibleStudies(state, bibleStudies) {
        state.bibleStudies = bibleStudies;
    },
    setBibleStudy(state, bibleStudy) {
        state.bibleStudy = bibleStudy;
    },
    setBibleStudyParticipants(state, bibleStudyParticipants) {
        state.bibleStudyParticipants = bibleStudyParticipants;
    },
    setAllBibleStudyParticipants(state, allBibleStudyParticipants) {
        state.allBibleStudyParticipants = allBibleStudyParticipants;
    },
    setBibleStudyAttendances(state, bibleStudyAttendances) {
        state.bibleStudyAttendances = bibleStudyAttendances;
    },
    setBibleStudyAttendance(state, bibleStudyAttendance) {
        state.bibleStudyAttendance = bibleStudyAttendance;
    },
    setEligibleParticipants(state, eligibleParticipants) {
        state.eligibleParticipants = eligibleParticipants;
    },
    setEligibleLeaders(state, eligibleLeaders) {
        state.eligibleLeaders = eligibleLeaders;
    },
    setCancelReasons(state, cancelReasons) {
        state.cancelReasons = cancelReasons;
    },
    setError(state, error) {
        state.error = error.toString();
    },
    setLoading(state, loading) {
        state.loading = loading;
    }
};
